import { EligibilityView } from "./getEligibilityView";

export interface CompanyStepStateInput {
  /** A company is registered on the folder. */
  hasCompany: boolean;
  /** Subsidiaries, accounting data and verdict are being (re)loaded. */
  isLoading: boolean;
  /** Verdict of the back, null while nothing is loaded. */
  view: EligibilityView | null;
}

export interface CompanyStepState {
  /** Subsidiaries and accounting data sections: greyed out and without any action. */
  sectionsDisabled: boolean;
  /** The pricing step is reachable. */
  canGoNext: boolean;
}

/**
 * State of the legal protection first step. The verdict is the back's: nothing is computed here,
 * and an unknown verdict (nothing loaded yet, or a load still running) keeps the step closed.
 */
export const getCompanyStepState = ({ hasCompany, isLoading, view }: CompanyStepStateInput): CompanyStepState => ({
  sectionsDisabled: !hasCompany,
  canGoNext: hasCompany && !isLoading && view?.canContinue === true
});
